import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthenticator } from "@aws-amplify/ui-react";
import dynamic from "next/dynamic";
import useSWR from "swr";
import LogRocket from "logrocket";
import type { GetServerSideProps } from "next";
import { fetchUserAttributes } from "@aws-amplify/auth/server";
import ContentLayout from "../components/Layout/ContentLayout";
import { fetchPostJSON } from "../utils/api-helpers";
import { runWithAmplifyServerContext } from "../utils/amplifyServerUtils";
import { RemainingApiResponseData } from "../src/types";

const CreateStoryComponent = dynamic(() => import("../components/CreateStory"));

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  try {
    const userAttributes = await runWithAmplifyServerContext({
      nextServerContext: { request: req, response: res },
      operation: (contextSpec) => fetchUserAttributes(contextSpec),
    });
    return {
      props: {
        email: userAttributes.email,
      },
    };
  } catch (err) {
    console.log(err);
    return {
      props: {
        email: null,
      },
    };
  }
};

function CreateStory({ email }) {
  const router = useRouter();
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
    if (authStatus === "authenticated" && user) {
      LogRocket.log("Adding user attribute...");
      LogRocket.identify(`'${email}'`);
    }
  }, [authStatus, user, router, email]);

  const { data } = useSWR<RemainingApiResponseData>("/api/remaining", () =>
    fetchPostJSON("/api/remaining", {
      id: user.userId,
    }),
  );

  let discover: boolean = false;
  const { feeling, subject, subOption, medium, styles, color } = router.query;
  if (feeling || subject || subOption || medium || styles || color) {
    discover = true;
  }

  if (!data) {
    return null;
  }
  return (
    <ContentLayout title="CreateFlow">
      <CreateStoryComponent
        feeling={feeling}
        subject={subject}
        subOption={subOption}
        medium={medium}
        styles={styles}
        color={color}
        discover={discover}
        remainingCredits={data.remainingGenerations}
      />
    </ContentLayout>
  );
}

export default CreateStory;
